import { useQuery } from '@tanstack/react-query';
import { fetchCoachingToken } from '../api/fetchCoachingToken';
import { COACHING_TOKEN_QUERY_KEY } from '../constants';

// Fetches a Coaching SSO token every time the view is entered.
// The token is never cached between visits (gcTime 0) and never auto-retried.
export const useCoachingToken = ({ enabled = true } = {}) => {
  const query = useQuery({
    queryKey: COACHING_TOKEN_QUERY_KEY,
    queryFn: fetchCoachingToken,
    enabled,
    staleTime: 0,
    gcTime: 0,
    retry: false,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  return {
    token: query.data ?? null,
    isLoading: query.isPending || query.isFetching,
    error: query.error,
  };
};
